import {Entity, PrimaryGeneratedColumn} from "typeorm/browser";
import {Column} from "typeorm";

@Entity("microrh")
export class MicroRH {
  @PrimaryGeneratedColumn("uuid")
  id?: string
  @Column({name: 'nm_micro'})
  nome?: string
  @Column({name: 'sigla_uf'})
  uf?: string
  // @Column()
  // nomeMacro?: string
  @Column()
  excluido?: boolean
  get nomeCompleto(): string {
    return this.nome + " - " + this.uf //+ " - " + this.nomeMeso
  }
}

